import { observer } from "mobx-react-lite";

import { IconFullscreen, IconViewer } from "@synthesis/shared-icons";
import { getApiBaseUrl } from "@synthesis/shared-services";
import { saveModelIdsAtRedis } from "@synthesis/shared-services/viewer/modelIdCacheController/client";
import { Button, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import { useStores } from "../../../store";

const Model = observer(({ isAssembly }: { isAssembly?: boolean }) => {
  const { generalStore } = useStores();

  const handleClick = () => {
    const models = Array.from(generalStore.checkedFiles.values())
      .map((e) => e.id)
      .join(",");

    void (async () => {
      const modelsId: string[] = models.split(",");
      const generateModelId = (await saveModelIdsAtRedis({ body: { modelIds: modelsId } })).data;
      const url = `${getApiBaseUrl()}/viewer/#/${generalStore.projectId}?models=${generateModelId}`;
      window.open(url, "_blank")?.focus();
    })();
  };

  const is3DModel =
    generalStore.checkedFiles.size > 0 &&
    !Array.from(generalStore.checkedFiles.values()).find((e) => e.type === "DOCUMENT" || e.type === "PDF_DOCUMENT") &&
    Array.from(generalStore.checkedFiles.values()).find((e) => e.type === "MODEL");

  if (!isAssembly) {
    return (
      <Tooltip arrowSide="bottom" description="Открыть отдельно">
        <Button
          disabled={!is3DModel || generalStore.checkedFiles.size !== 1}
          theme="text"
          onClick={handleClick}
          leftIcon={
            <IconFullscreen data-cy="modelButton-iconFullscreen" className={cn("size-5", generalStore.checkedFiles.size !== 1 && "text-[#d0c6c3]")} />
          }
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip arrowSide="bottom" description="Открыть сборку">
      <Button
        onClick={handleClick}
        disabled={!is3DModel || generalStore.checkedFiles.size < 2}
        size="sm"
        leftIcon={<IconViewer data-cy="modelButton-iconViewer" className="size-5" />}
      >
        Открыть сборку
      </Button>
    </Tooltip>
  );
});

export default Model;
